import { dateFormat, subtractMonthsFromDate } from '@capitalise/utils';
import { differenceInMonths } from 'date-fns';
import { CompanyTypeFromLabel } from 'enums/company-type';
import { CreditScoreFromLetterToType, CreditScoreLetter } from 'enums/credit-score-type';
import { SectorLabelToType } from 'enums/sector-type';

export const mapProfileToEditForm = (
  section: string,
  profileId: string,
  newProfileCompanyDetails,
) => {
  return [
    {
      section,
      completed: false,
      profileId,
      data: {
        companyName: newProfileCompanyDetails.name,
        companyNumber: newProfileCompanyDetails.registrationNumber,
        companyTradingName: newProfileCompanyDetails.name,
        companyType: newProfileCompanyDetails.type
          ? CompanyTypeFromLabel[newProfileCompanyDetails.type]
          : null,
        companyWebsite: null,
        contactEmail: newProfileCompanyDetails.contactEmail,
        contactName: newProfileCompanyDetails.contactName,
        contactPhone: newProfileCompanyDetails.contactNumber,
        creditScore: CreditScoreFromLetterToType[newProfileCompanyDetails.score],
        numberOfEmployees: newProfileCompanyDetails.employeesNumber,
        postalCode: newProfileCompanyDetails.tradingAddress?.postalCode,
        city: newProfileCompanyDetails.tradingAddress?.city,
        houseNumber: newProfileCompanyDetails.tradingAddress?.houseNumber,
        sector: SectorLabelToType[newProfileCompanyDetails.sector],
        sectorName: newProfileCompanyDetails.sector,
        tradingFrom: newProfileCompanyDetails.tradingFromDate
          ? new Date(newProfileCompanyDetails.tradingFromDate).getTime() / 1000
          : null,
        tradingPeriod: newProfileCompanyDetails.tradingFromDate
          ? differenceInMonths(new Date(), new Date(newProfileCompanyDetails.tradingFromDate))
          : null,
        vatStatus: newProfileCompanyDetails.vatStatus,
        originalData: newProfileCompanyDetails,
      },
    },
  ];
};

export const mapEditFormToProfilePayload = (formData) => {
  const tradingFromDate = dateFormat(
    subtractMonthsFromDate(new Date(), formData.tradingPeriod),
    'yyyy-MM-dd',
  );

  return {
    ...formData.originalData,
    name: formData.companyName,
    registrationNumber: formData.companyNumber,
    sector: formData.sectorName,
    tradingFromDate,
    score: CreditScoreLetter[formData.creditScore],
    contactEmail: formData.contactEmail,
    contactNumber: formData.contactPhone,
    contactName: formData.contactName,
    vatStatus: formData.vatStatus,
    ...(formData.originalData.tradingAddress?.postalCode === formData.postalCode &&
    formData.originalData.tradingAddress?.houseNumber === formData.houseNumber &&
    formData.originalData.tradingAddress?.city === formData.city
      ? {}
      : {
          tradingAddress: {
            postalCode: formData.postalCode,
            houseNumber: formData.houseNumber,
            city: formData.city,
          },
        }),
  };
};
